<div class="container">
	<form [formGroup]="formGroup" class="container__form">
		<form-section [title]="'DRAWERS.CREATION.SECTIONS.PARAMETERS' | translate">
			<form-row>
				<form-field>
					<free-text-input
						[formControlName]="NAME_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.RECIPIENT_NAME.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.RECIPIENT_NAME.LABEL'"
					>
					</free-text-input>
				</form-field>
				<form-field>
					<free-text-input
						[formControlName]="EMAIL_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.EMAIL.LABEL' | translate"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.EMAIL.LABEL' | translate"
					>
					</free-text-input>
				</form-field>
			</form-row>
			<form-row>
				<form-field>
					<free-text-input
						[formControlName]="ADDRESS_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.ADDRESS.LABEL' | translate"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.ADDRESS.LABEL' | translate"
					>
					</free-text-input>
				</form-field>
				<form-field>
					<free-text-input
						[formControlName]="TAX_ID_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.TAX_ID.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.TAX_ID.LABEL'"
						[isLtr]="true"
					>
					</free-text-input>
				</form-field>
			</form-row>
		</form-section>
	</form>
	<form-actions class="container__buttons-wrapper">
		<submit-button [title]="'DRAWERS.BUTTONS.CLEAR_ALL' | translate" (onClick)="onClearAll()"></submit-button>
		<submit-button [title]="'DRAWERS.BUTTONS.SEARCH' | translate" [filled]="true" (onClick)="onSubmit()"></submit-button>
	</form-actions>
</div>
